import styled from 'styled-components';

export const Wrapper = styled.div`
	height: 50px;
	background: white;
    padding: 0 16px;
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	position: fixed;
	bottom: 0;
    z-index: 999;
    ${p => p.isMobile === false && `
        box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.20);
    `
    }
    ${p => p.appPromptClose === false
        ? 
        `
            box-shadow: 0px 0px 4px 2px rgb(233,247,245);
        `
        : 
        `
            box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.20);
        `
    }
    @media (min-width: 1100px) {
        display: none;
    }
    .item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        width: 25%;
    }
    .label {
        color: black;
        font-size: 13px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        width: 100%;
        text-align: center;
    }
    .icon {
        width: 20px;
        height: 20px;
        color: black;
    }
`
